import { PolicyConfiguration, PolicyLimitConfiguration, POLICY_TYPE, POLICY_LIMIT_TYPE } from "./policy-configuration";
import * as _ from "lodash";
import moment from "moment";
import "moment-timezone";

export class OpeningHoursPolicy extends PolicyConfiguration {
  constructor(identifier, policyLevel) {
    super(identifier, POLICY_TYPE.OpeningHours, policyLevel);

    this.limits = [];
  }

  toString() {
    let limitsString = 'No limits';
    if (this.limits && this.limits.length > 0) {
      limitsString = this.limits
        .map(l => Object.assign(new OpeningHoursPolicyLimit(), l))
        .map(ohpl => ohpl.toString())
        .join(', ');
    }
    return `${POLICY_TYPE.nameof(this.policyType)} (${limitsString})`;
  }

  toLocalString(olsonTimeZone) {
    let limitsString = 'No limits';
    if (this.limits && this.limits.length > 0) {
      limitsString = this.limits
        .map(l => Object.assign(new OpeningHoursPolicyLimit(), l))
        .map(ohpl => ohpl.toLocalString(olsonTimeZone))
        .join(', ');
    }
    return `${this.identifier}: ${POLICY_TYPE.nameof(this.policyType)} (${limitsString})`;
  }

  isValid() {
    let isValid = !!this.identifier && !!this.identifier.trim();
    if (this.limits && this.limits.length > 0) {
      isValid = isValid && this.limits
        .map(l => Object.assign(new OpeningHoursPolicyLimit(), l))
        .every(l => l.isValid());
    }
    return isValid;
  }

  static fromJSON(json) {
    if (!json) return undefined;

    return Object.assign(new OpeningHoursPolicy(), json);
  }
}

export class OpeningHoursPolicyLimit extends PolicyLimitConfiguration {
  constructor(limitType, openingTime, closingTime) {
    super('OpeningHoursPolicyLimitConfiguration', limitType);

    this.openingTime = openingTime;
    this.closingTime = closingTime;
  }

  static fromJSON(json) {
    if (!json) return undefined;

    return Object.assign(new OpeningHoursPolicyLimit(), json);
  }

  toString() {
    return `${POLICY_LIMIT_TYPE.nameof(this.limitType)}: ${this.formatOpeningTime()}-${this.formatClosingTime()}`;
  }

  toLocalString(olsonTimeZone) {
    return `${POLICY_LIMIT_TYPE.nameof(this.limitType)}: ${this.formatLocalOpeningTime(olsonTimeZone)}-${this.formatLocalClosingTime(olsonTimeZone)}`;
  }

  isValid() {
    const openingTimeIsValid =
      !!this.openingTime && !!this.openingTime.trim() && _.split(this.openingTime, ':').length > 1;

    const closingTimeIsValid =
      !!this.closingTime && !!this.closingTime.trim() && _.split(this.closingTime, ':').length > 1;

    const areEqual = !!this.openingTime && !!this.closingTime && this.closingTime.trim() === this.openingTime.trim();

    return openingTimeIsValid && closingTimeIsValid && !areEqual;
  }

  formatOpeningTime() {
    return this.getHoursMinutesString(this.openingTime);
  }

  formatClosingTime() {
    return this.getHoursMinutesString(this.closingTime);
  }

  formatLocalOpeningTime(olsonTimeZone) {
    return this.getLocalHoursMinutesString(this.openingTime, olsonTimeZone);
  }

  formatLocalClosingTime(olsonTimeZone) {
    return this.getLocalHoursMinutesString(this.closingTime, olsonTimeZone);
  }

  getHoursMinutesString(timespanString) {
    const momentDuration = moment.duration(timespanString);
    const hours = _.padStart(momentDuration.hours(), 2, '0');
    const minutes = _.padStart(momentDuration.minutes(), 2, '0');
    return `${hours}:${minutes}`
  }

  getLocalHoursMinutesString(timespanString, olsonTimeZone) {
    const momentDuration = moment.duration(timespanString);
    const hours = momentDuration.hours();
    const minutes = _.padStart(momentDuration.minutes(), 2, '0');
    const fakeUtcMoment = moment.utc().hours(hours);
    const fakeLocalMomentAtVenue = fakeUtcMoment.tz(olsonTimeZone);
    const localHours = _.padStart(fakeLocalMomentAtVenue.hours(), 2, '0');
    return `${localHours}:${minutes}`
  }
}


